import React, { useContext } from 'react'
import styled from 'styled-components'
import { FieldGroup, Label } from '../../layout/mixins'
import Checkbox from '../Checkbox'
import Context from '../../context'

const AcceptTerms = () => {
  const { getValue, setField } = useContext(Context)
  return (
    <FieldGroup>
      <Label>
        <Checkbox
          name="accept"
          value="true"
          onChange={setField('accept')}
          defaultChecked={!!getValue('accept')}
          required
        />
        <span>Jag bekräftar att lämnade uppgifter är riktiga och enligt gällande regler, samt ovan punkter.</span>
      </Label>
    </FieldGroup>
  )
}

export default AcceptTerms